import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ClientsDataServiceProvider {
	private CLIENTS_URL = '/protected/rest/clients/v2';
	private CLIENT_VIEW_URL = '/protected/rest/clients';
	private newClient: BehaviorSubject<any> = new BehaviorSubject(false);
	private updatedClient: Subject<any> = new Subject();

	constructor(public http: HttpClient) {}

	get clientObservable() {
		return this.newClient.asObservable();
	}

	get updatedClientEvent() {
		return this.updatedClient.asObservable();
	}

	emitClient(client) {
		return this.newClient.next(JSON.parse(JSON.stringify(client)));
	}

	emitUpdateClientEvent(data?) {
		return this.updatedClient.next(data);
	}

	getClient(clientId) {
		const url = `${this.CLIENT_VIEW_URL}/client`;
		const params = new HttpParams().set('id', clientId);
		return this.http.get(url, { params });
	}

	getClientsOnPage(pageRequest, status) {
		const {
			perPage,
			page,
			pageOrder: { predicate, reverse },
			search
		} = pageRequest;
		const url = this.CLIENTS_URL;
		let params = new HttpParams();
		params = params.append('perPage', perPage);
		params = params.append('page', page);
		params = params.append('predicate', predicate);
		params = params.append('reverse', reverse);
		params = params.append('search', search);
		params = params.append('status', status);

		return this.http.get(url, { params });
	}

	addNewClient = client => {
		const url = '/protected/rest/clients/add';
		return this.http.post(url, client);
	};

	updateClient = client => {
		const url = '/protected/rest/clients/update';
		return this.http.post(url, client);
	};

	searchClient = searchClient => {
		const url = '/protected/rest/job/client/search';
		let params = new HttpParams();
		params = params.append('search', searchClient);
		return this.http.get(url, { params });
	};

	deleteClient = clientId => {
		const url = `/api/user/v1/clients/${clientId}/delete`;
		return this.http.delete(url);
	};

	changeClientSubscription = contact => {
		const subscribe = { value: contact.status !== 'SUBSCRIBED' };
		const url = `/api/user/client/${contact.id}/subscription`;
		return this.http.post(url, subscribe);
	};

	checkBeforeDelete = clientId => {
		const url = `/api/user/v1/clients/${clientId}/validate-for-delete`;
		return this.http.get(url);
	};

	saveOptIn = (clientId: number, statement: string) => {
		const url = '/api/user/consent/';
		return this.http.post(url, {
			contactId: clientId,
			text: statement
		});
	};

	deleteConsent = (contactId: number, consentId: number) => {
		const url = '/api/user/consent/';
		return this.http.request('delete', url, {
			body: {
				contactId,
				consentId
			}
		});
	};
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/client/clients.data.service.ts